import { Box, useMantineColorScheme } from "@mantine/core";
import "@bi-studio/shared/styles/theme.css";
import * as React from "react";

export default function RootLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    const { colorScheme } = useMantineColorScheme();

    // Sync Mantine color scheme with Tailwind .dark class
    React.useEffect(() => {
        if (colorScheme === 'dark') {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, [colorScheme]);

    return (
        <Box
            mih="100vh"
        >
            {children}
        </Box>
    );
}
